<template>
  <div class="el-card  pd20 posters">
    <h4>测评商品</h4>
    <el-divider></el-divider>
    <el-form  :model="form" label-width="80px">
      <!--  -->
      <el-form-item v-for="(item,index) in buyList" :key="index" :label="item.name" :label-width="formLabelWidth">
        <el-input  v-model="form[index]"></el-input>
      </el-form-item>
      <!--  -->
      <el-form-item :label-width="formLabelWidth">
        <el-button type="primary" @click="submitForm">充 值</el-button>
        <el-button  @click="$router.go(-1)">返 回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { getProducts,charge} from "@/api/consultant";
export default {
  data() {
      return {
        buyList:[],
        formLabelWidth: '140px',
        form: {}
      }
    },
    methods: {
      //提交数据
      submitForm() {
          let arr = [];
          for(let i =0;i<this.buyList.length;i++){
              if(this.form[i]){
                  arr.push({
                    product_id:this.buyList[i].id,
                    count:this.form[i],
                });
              }
              
          }
        charge({
            id:this.$route.query.id,
            list:JSON.stringify(arr)
        }).then((data) => {
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.$notify({
            title: '成功',
            message: '充值成功！',
            type: 'success'
          });
          this.$router.go(-1);
        });
      },
      pullData() {
        this.$showLoading();
        getProducts().then((data)=>{
          if (data.error > 0) {
            this.$message(data.msg);
            return
          }
          this.buyList = data.list;
          this.$hideLoading();
        }).catch((err)=>{
            this.$hideLoading();
        });
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss" scoped>
.posters {
  .el-input,
  .el-textarea {
    width: 500px;
  }
}

.up-image {
  margin: 20px auto auto;
  width: 187.5px;
  text-align: center;
  border-radius: 8px;
  .error {
    border-radius: 8px;
    background-color: rgba($color: #eeeeee, $alpha: .5);
  }
}
</style>
